export default __webpack_public_path__ + "static/media/pdf-icon.6b466e43.svg";